import { FirstPasswordData } from './../../../core/models/first-password-change.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../../core/services/user.service';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { MustMatch } from './_helper';

@Component({
	selector: 'app-new-password',
	templateUrl: './new-password.component.html',
	styleUrls: ['./new-password.component.scss'],
})
export class NewPasswordComponent implements OnInit {
	newPasswordForm: FormGroup;
	fieldTextType: boolean;
	fieldTextTypeConfirm: boolean;

	constructor(
		private userService: UserService,
		private fb: FormBuilder,
		private router: Router,
		private toastr: ToastrService
	) {}

	ngOnInit(): void {
		this.initPassForm();

		if (localStorage.getItem('challengeName') == null) {
			this.router.navigateByUrl('/auth');
		}
	}

	private initPassForm(): void {
		this.newPasswordForm = this.fb.group(
			{
				password: [
					'',
					[
						Validators.required,
						Validators.minLength(8),
						Validators.pattern(
							'^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.]).{8,}$'
						),
					],
				],
				confirmPassword: ['', [Validators.required]],
			},
			{
				validators: MustMatch('password', 'confirmPassword'),
			}
		);
	}

	public toggleFieldTextType(): void {
		// Changes the display style on password fields
		// Password <-> Text
		this.fieldTextType = !this.fieldTextType;
		this.changeIcon();
	}

	public toggleFieldTextTypeConfirm(): void {
		this.fieldTextTypeConfirm = !this.fieldTextTypeConfirm;
		this.changeIconConfirm();
	}

	public changeIcon(): string {
		// Change the icon for show / not show password characters
		if (this.fieldTextType) {
			return 'visibility';
		} else {
			return 'visibility_off';
		}
	}

	public changeIconConfirm(): string {
		if (this.fieldTextTypeConfirm) {
			return 'visibility';
		} else {
			return 'visibility_off';
		}
	}

	public newPassword(): void {
		if (
			localStorage.getItem('challengeName') != null ||
			localStorage.getItem('challengeName') !== undefined
		) {
			const userId = localStorage.getItem('userId');
			const session = localStorage.getItem('session');
			const challengeName = localStorage.getItem('challengeName');

			const newPassword = this.newPasswordForm.value.password;

			const data: FirstPasswordData = {
				challenge_name: challengeName,
				session,
				user_id: userId,
				new_password: newPassword,
			};

			this.userService.changeFirstPasswordOp(data).subscribe((res: any) => {
				if (res.AuthenticationResult) {
					this.toastr.success(
						'Senha atualizada com sucesso. Por favor, faça login novamente.'
					);
					localStorage.clear();
					this.router.navigateByUrl('/auth');
				}
			});
		} else if (
			localStorage.getItem('codeReset') != null ||
			localStorage.getItem('codeReset') !== undefined
		) {
			const code = localStorage.getItem('codeReset');
			const email = localStorage.getItem('emailReset');
			const password = this.newPasswordForm.value.password;
			const data = {
				username: email,
				confirmation_code: code,
				new_password: password,
			};

			this.userService.forgotConfirmPassword(data).subscribe((res: any) => {
				localStorage.removeItem('codeReset');
				localStorage.removeItem('emailReset');
				this.router.navigateByUrl('auth');
			});
		}
	}
}
